import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { logout } from '../../store/ducks/auth'
import { version } from '../../../package.json'

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  render() {
    const { logout } = this.props
    const { user } = this.props.auth

    return (
      <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block user-dropdown">
        <DropdownToggle tag="button" className="btn header-item waves-effect" id="page-header-user-dropdown">
          <img className="rounded-circle header-profile-user mr-1" src={user.avatar || null} alt="Avatar" />
          <span className="d-none d-xl-inline-block ml-1 text-transform">{user.givenName || 'Usuário'}</span>
          <i className="mdi mdi-chevron-down d-none ml-1 d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu right>
          <Link to="/atendimento">
            <DropdownItem>
              Atendimento
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          {/* <Link to="/perfil">
            <DropdownItem>
              Perfil
            </DropdownItem>
          </Link>
          <DropdownItem divider /> */}
          <Link to="/colaborador/solicitacoes">
            <DropdownItem>
              Solicitações
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/aprovacoes">
            <DropdownItem>
              Aprovações
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/carteira">
            <DropdownItem>
              Carteira
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/feedback/novo">
            <DropdownItem>
              Enviar feedback
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/meusfornecedores">
            <DropdownItem>
              Gestão de Fornecedores
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/gestao-de-minutas">
            <DropdownItem>
              Gestão de Minutas
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/minhas-transcricoes">
            <DropdownItem>
              Minhas transcrições
            </DropdownItem>
          </Link>
          {
            (user.perm_id === 1 || user.perm_id === 2 || user.perm_id === 3) && (
              <>
                <DropdownItem divider />
                <Link to="/gerencia/vincular-cases">
                  <DropdownItem>
                    Vincular Cases
                  </DropdownItem>
                </Link>
                <Link to="/gerencia/vincular-atestados">
                  <DropdownItem>
                    Vincular Atestados
                  </DropdownItem>
                </Link>
              </>
            )
          }
          {
            (user.perm_id === 1) && (
              <>
                <DropdownItem divider />
                <DropdownItem tag={Link} to="/ui-playground" onClick={() => this.setState({ menu: false })}>
                  Playground UI
                </DropdownItem>
                <DropdownItem tag={Link} to="/erp-design-catalog" onClick={() => this.setState({ menu: false })}>
                  Catálogo ERP (do zero)
                </DropdownItem>
                <DropdownItem tag={Link} to="/admin" onClick={() => this.setState({ menu: false })}>
                  Administrador
                </DropdownItem>
              </>
            )
          }
          <DropdownItem divider />
          <DropdownItem className="text-danger" onClick={() => logout()}>
            {/* <i className="ri-shut-down-line align-middle mr-1 text-danger" /> */}
            {'Sair da conta'}
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem disabled>
            {`v${version}`}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu)
